import { AuthState } from "../base/AuthState";
import template from "./ForgotPasswordTemplate.html";
import sentTemplate from "./ForgotPasswordSentTemplate.html";

import { _lcs, currentLanguage } from "../../i18n";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * ForgotPasswordState — "Passwort vergessen?" from the login (#/password-forgotten).
 *
 * Has the core-api mail a reset link (POST /auth/password-reset). The link
 * leads back to this house's guest-app — TokenState, which hands the
 * resetPassword token on to PasswordResetState.
 *
 * The confirmation reads the same whether or not the address has an account:
 * the API answers 200 either way so nobody can probe which addresses exist.
 */
export class ForgotPasswordState extends AuthState
{
    static ROUTE = "/password-forgotten";
    static ID = "password-forgotten";

    async enter()
    {
        this.sending = false;
        this.renderAuth( template, {} );

        this.bind( "back", () => this.app.router.redirect( "/login" ) );
        this.bind( "to-login", ( e ) =>
        {
            e.preventDefault();
            this.app.router.redirect( "/login" );
        } );

        const form = document.getElementById( "forgot-form" );
        this.addEventListener( form, "submit", ( e ) => this.onSubmit( e ) );
    }

    async onSubmit( e )
    {
        e.preventDefault();
        if ( this.sending )
        {
            return;
        }

        const errorEl = document.querySelector( '[data-id="forgot-error"]' );
        const email = ( document.getElementById( "forgot-email" )?.value || "" ).trim();
        errorEl.hidden = true;

        if ( !EMAIL_RE.test( email ) )
        {
            return this._showError( errorEl, _lcs( "Bitte gib eine gültige E-Mail-Adresse ein." ) );
        }

        const submitBtn = document.querySelector( '[data-id="send"]' );
        this._setLoading( submitBtn, true );
        try
        {
            const payload = {
                email,
                app : "guest",
                // The mail is written in this language …
                language : currentLanguage()
            };
            // … and its link leads back to this house.
            const slug = this.app.theme.getTenantSlug();
            if ( slug ) payload.slug = slug;

            const { result } = await this.app.api.post( "/auth/password-reset", payload );
            if ( !result || +result.status !== 200 )
            {
                throw new Error( "Unexpected password-reset response." );
            }

            this.renderAuth( sentTemplate, { email } );
            this.bind( "to-login", () => this.app.router.redirect( "/login" ) );
        }
        catch ( err )
        {
            console.error( err );
            this._setLoading( submitBtn, false );
            this._showError( errorEl, +err?.status === 400
                ? _lcs( "Bitte gib eine gültige E-Mail-Adresse ein." )
                : _lcs( "Der Link konnte nicht angefordert werden. Bitte versuche es später erneut." ) );
        }
    }

    bind( id, handler )
    {
        const el = document.querySelector( '[data-id="' + id + '"]' );
        if ( el ) this.addEventListener( el, "click", handler );
    }

    _setLoading( btn, on )
    {
        if ( !btn ) return;
        btn.disabled = on;
        btn.setAttribute( "aria-busy", String( on ) );
    }

    _showError( el, message )
    {
        if ( !el ) return;
        el.textContent = message;
        el.hidden = false;
    }

    async exit() {}
}
